import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { Classroom } from 'types/classroom';

export const CLASSROOMS_KEY = 'classrooms';

function getClassrooms({
  schoolyearId,
  schoolId,
}: {
  schoolyearId: string;
  schoolId: string;
}) {
  return request(
    `/schoolyears/${schoolyearId}/schools/${schoolId}/classrooms`,
    {
      method: 'GET',
    },
  ).then<Classroom[]>(res => res.data);
}

export default function useClassrooms() {
  const { school, schoolyear } = useSchoolSchoolyear();
  return useQuery({
    queryKey: [CLASSROOMS_KEY, school.id, schoolyear.id],
    queryFn: () =>
      getClassrooms({ schoolyearId: schoolyear.id, schoolId: school.id }),
    refetchOnWindowFocus: false,
    retry: 1,
  });
}

export function useClassroomsWithoutProvider(props: {
  schoolyearId?: string;
  schoolId?: string;
}) {
  const schoolId = props.schoolId || '';
  const schoolyearId = props.schoolyearId || '';
  return useQuery({
    queryKey: [CLASSROOMS_KEY, schoolId, schoolyearId],
    queryFn: () => getClassrooms({ schoolId, schoolyearId }),
    refetchOnWindowFocus: false,
    enabled: !!props.schoolId && !!props.schoolyearId,
  });
}
